import { Box, Button, Paper, Typography, useTheme, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './ConfirmPassword.module.css'
import logo from '../../Assets/Images/BuildLinkCompleteLogo.png'
import buildBid from '../../Assets/Images/Build-BID2.png'
import buildStudio from '../../Assets/Images/BuildStudiologo-gold.png'
import banner_right from '../../Assets/Images/banner_right.png'
import grid from '../../Assets/Images/Group194.png'
import {
    AlertCmp,
    BackDropCmp,
    InputCmp,
    LottieFilesCmp,
} from '../../Components'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { ConfirmPasswordAction } from '../../Store/Actions/AuthActions'
import useAlert from '../../Hooks/useAlert/useAlert'
import { ForgetPasswordAnimation } from '../../Assets'
import buildVid from '../../Assets/Images/buildvids-logo.png'
import linksurance from '../../Assets/Images/linksurance-logo.png'
import buildLink from '../../Assets/Images/BuildLinkCompleteLogo.png'

export default function ConfirmPassword() {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const isTablet = useMediaQuery(theme.breakpoints.down('md'))
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

    const otpCode = location.state

    const { confirmPasswordLoading } = useSelector(
        (state) => state.ConfirmPasswordReducers
    )

    const { setAlert } = useAlert()

    useEffect(() => {
        if (!otpCode) {
            navigate('/')
        }
    }, [])

    const validationSchema = Yup.object({
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters')
            .max(16, 'Password must not exceed 16 characters')
            .matches(
                /[A-Z]/,
                'Password must contain at least one uppercase letter'
            )
            .matches(
                /[a-z]/,
                'Password must contain at least one lowercase letter'
            )
            .matches(
                /[\W_]/,
                'Password must contain at least one special character'
            ),
        password_confirmation: Yup.string()
            .required('Confirm password is required')
            .oneOf(
                [Yup.ref('password'), null],
                'Password and confirm password do not match'
            ),
    })

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            password: '',
            password_confirmation: '',
        },
        resolver: yupResolver(validationSchema),
    })

    const [notificationToken, setNotificationToken] = useState(null)

    const onSubmit = (obj) => {
        const objToSend = {
            ...obj,
            code: otpCode,
        }
        console.log(objToSend, 'objToSend haha')
        dispatch(ConfirmPasswordAction(objToSend, setAlert, navigate))
    }

    return (
        <Box 
            sx={{
                display: 'flex',
                minHeight: '100vh',
                backgroundColor: '#EFF5FD',
                flexDirection: { xs: 'column', lg: 'row' }
            }}
        >
            {/* Main Content Area */}
            <Box
                component={Paper}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: 'none',
                    height: { xs: 'auto', lg: '100vh' },
                    justifyContent: 'center',
                    width: { xs: '100%', lg: '60%' },
                    alignItems: { xs: 'center', lg: 'flex-start' },
                    padding: {
                        xs: '2rem 1rem',
                        sm: '3rem 2rem',
                        md: '4rem 3rem',
                        lg: '6.4rem'
                    },
                    backgroundColor: '#EFF5FD',
                    minHeight: { xs: '100vh', lg: 'auto' }
                }}
            >
                <Box
                    sx={{
                        width: { xs: '100%', sm: '32rem' },
                        maxWidth: '32rem',
                        margin: { xs: '0 auto', lg: '0' },
                        backgroundColor: {xs: 'white', md: 'transparent'},
                        padding: {xs: '2rem 1rem',  md: '0'},
                        borderRadius: {xs: '20px'},
                    }}
                >
                    <Typography 
                        variant="h3" 
                        sx={{
                            marginTop: { xs: 2, lg: 4 },
                            letterSpacing: '-0.025em',
                            lineHeight: 1.25,
                            fontWeight: 800,
                            fontSize: { xs: '1.75rem', sm: '2rem', lg: '2.2rem' },
                            textAlign: { xs: 'center', lg: 'left' }
                        }}
                        gutterBottom
                    >
                        Write Password
                    </Typography>
                    <Typography 
                        variant="subtitle2"
                        sx={{
                            textAlign: { xs: 'center', lg: 'left' },
                            marginBottom: 3
                        }}
                    >
                        Please enter your new password
                    </Typography>

                    <form
                        name="loginForm"
                        onSubmit={handleSubmit(onSubmit)}
                        style={{ width: '100%' }}
                    >
                        <Box sx={{ marginBottom: 3 }}>
                            <InputCmp
                                name="password"
                                control={control}
                                type="password"
                                label="Password"
                                autoFocus
                                className={styles.auth_form_field}
                            />
                        </Box>
                        <Box sx={{ marginBottom: 3 }}>
                            <InputCmp
                                name="password_confirmation"
                                control={control}
                                type="password"
                                label="Confirm Password"
                                className={styles.auth_form_field}
                            />
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                width: '100%',
                                marginTop: 2,
                                borderRadius: '28px',
                                backgroundColor: '#005699',
                                height: '48px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                '&:hover': {
                                    backgroundColor: '#004080'
                                }
                            }}
                            aria-label="Submit"
                            size="large"
                            type="submit"
                        >
                            Submit
                        </Button>
                    </form>
                </Box>

                {/* Social Media Logos - Hidden on mobile */}
                <Box
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        alignItems: 'center',
                        marginTop: 4,
                        justifyContent: 'space-around',
                        gap: 2,
                        width: '100%',
                        maxWidth: '32rem'
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={buildLink}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={buildStudio}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={buildBid}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={linksurance}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={buildVid}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                </Box>
            </Box>

            {/* Right Side Banner - Hidden on mobile and tablet */}
            <Box
                sx={{
                    display: { xs: 'none', lg: 'block' },
                    position: 'relative',
                    flex: 1,
                    height: '100vh',
                    backgroundColor: '#EFF5FD',
                    overflow: 'hidden'
                }}
            >
                <Box
                    sx={{
                        backgroundColor: '#cce3fc',
                        height: '80vh',
                        width: '420px',
                        position: 'absolute',
                        top: 0,
                        right: '70px',
                        borderBottomRightRadius: '220px',
                        borderBottomLeftRadius: '220px',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'absolute',
                            top: '80px',
                            left: 0,
                            right: 0
                        }}
                    >
                        <img
                            src={buildLink}
                            alt="logo"
                            style={{ width: '250px' }}
                        />
                    </Box>

                    <Box
                        sx={{
                            position: 'relative',
                            textAlign: 'center',
                            marginBottom: '15px',
                            width: '100%',
                            '&::before': {
                                content: '"\\201C"',
                                position: 'absolute',
                                top: '-55px',
                                left: '25px',
                                color: '#b3c5dc',
                                fontSize: '70px',
                                fontWeight: 800
                            },
                            '&::after': {
                                content: '"\\201D"',
                                position: 'absolute',
                                bottom: '-75px',
                                right: '30px',
                                color: '#b3c5dc',
                                fontSize: '70px',
                                fontWeight: 800
                            }
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 900,
                                fontSize: '33px',
                                position: 'relative'
                            }}
                        >
                            
                            Construction Business <br /> Networking Platform
                           
                        </Typography>
                    </Box>
                    
                    <Box
                        sx={{
                            fontSize: '1.6rem',
                            textWrap: 'nowrap',
                            textAlign: 'center',
                            borderTop: '3px solid black',
                            borderBottom: '3px solid black',
                            position: 'absolute',
                            bottom: '140px',
                            left: 0,
                            right: 0,
                            paddingTop: '7px',
                            paddingBottom: '7px',
                            letterSpacing: '1px',
                            fontFamily: 'Arial, Helvetica, sans-serif'
                        }}
                    >
                        "Trust the Pros the Pros trust"
                    </Box>
                </Box>

                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '70px',
                        right: '70px',
                        textAlign: 'end',
                        fontWeight: 'lighter',
                        display: 'flex',
                        flexDirection: 'column',
                        width: '150%'
                    }}
                >
                    <Typography variant="subtitle2">
                        <a
                            href="https://staging.buildlink.com/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            Privacy Policy
                        </a>
                        {' | '}
                        <a
                            href="https://staging.buildlink.com/terms-of-service"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            Terms of Services
                        </a>
                        {' | '}
                        <a
                            href="https://staging.buildlink.com/disclaimer"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            Disclaimer
                        </a>
                        {' | '}
                        <a
                            href="https://staging.buildlink.com/copyright-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            Copyright Policy
                        </a>
                    </Typography>
                    <Typography variant="subtitle2">
                        © {new Date().getFullYear()} Buildlink.com
                    </Typography>
                </Box>
            </Box>
            <BackDropCmp setOpen={confirmPasswordLoading} />
        </Box>
    )
}
